import { NgModule } from "@angular/core";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatIconModule } from "@angular/material/icon";
import { MaterialModule } from "../material.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { DentalEmrComponent } from "./Dental-Emr.component";
import { DentalEmrRoutingModule } from "./Dental-Emr.routing";
import { DentalWorkupComponent } from "./Dental-Workup/dental-workup.component";
import { ProceduresDentalChartComponent } from "./Procedures-Dental-Chart/procedures-dental-chart.component";
import { DentalChartComponent } from "./Dental-Chart/dental-chart.component";
import { DentalPastHistoryComponent } from "./Dental-History/dental-past-history/dental-past-history.component";
import { DentalSurgicalHistoryComponent } from "./Dental-History/dental-surgical-history/dental-surgical-history.component";
import { DentalFamilyHistoryComponent } from "./Dental-History/dental-family-history/dental-family-history.component";
import { DentalSocialHistoryComponent } from "./Dental-History/dental-social-history/dental-social-history.component";
import { DentalDrugAllergyComponent } from "./Dental-History/dental-drug-allergy/dental-drug-allergy.component";
import { DentalOtherInfoComponent } from "./Dental-History/dental-other-info/dental-other-info.component";
import { CommonModule } from "@angular/common";
import { PerioChartComponent } from "./Perio-Chart/perio-chart.component";
@NgModule({
  imports: [
    MatExpansionModule,
    MatIconModule,
    DentalEmrRoutingModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    CommonModule,
  ],
  declarations: [
    DentalEmrComponent,
    DentalWorkupComponent,
    ProceduresDentalChartComponent,
    DentalChartComponent,
    DentalPastHistoryComponent,
    DentalSurgicalHistoryComponent,
    DentalFamilyHistoryComponent,
    DentalSocialHistoryComponent,
    DentalDrugAllergyComponent,
    DentalOtherInfoComponent,
    PerioChartComponent,
  ],
})
export class DentalEmrModule {}
